import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { AlertModule, ComponentsModule } from '@ed---interne/ng-uui-components';

import { MainComponent } from './main.component';
import { HomeComponent } from './home/home.component';
import { StatsComponent } from './stats/stats.component';
import { ContactComponent } from './contact/contact.component';
import { SimulationsComponent } from './simulation/simulations.component';
import { SimulationNewNetworkComponent } from './simulation/simulation-new-network/simulation-new-network.component';
import { SimulationExistingNetworkComponent } from './simulation/simulation-existing-network/simulation-existing-network.component';
import { SimulateNewNetworkComponent } from './simulation/modals/simulate-new-network/simulate-new-network.component';

import { AccountComponent } from './settings/account/account.component';
import { AccountPasswordEditComponent } from './settings/edit-password/account-password-edit.component';

import { UsersComponent } from '../admin/users/users.component';

import { SharedModule } from '../../shared/shared.module';

import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';

@NgModule({
    declarations: [
        StatsComponent,
        ContactComponent,
        UsersComponent,
        AccountComponent,
        AccountPasswordEditComponent,
        // SimulateNewNetworkComponent,
        // SimulationNewNetworkComponent,
        // SimulationExistingNetworkComponent,
    ],
    imports: [
        RouterModule,
        CommonModule,
        SharedModule,

        MainComponent,
        HomeComponent,
        SimulationsComponent,

        ComponentsModule,
        AlertModule,

        FormsModule,
        ReactiveFormsModule,
        MatMenuModule,
        MatSidenavModule,
    ],
    exports: [StatsComponent],
})
export class MainModule {}
